///<reference types="pixi.js"/>
namespace pixi_heaven {
    (PIXI as any).heaven = pixi_heaven;
}
